"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * API configuration
 */
var ApiConfig = /** @class */ (function () {
    function ApiConfig(sportsApiUrl, sportsApiPushUrl) {
        this.sportsApiUrl = sportsApiUrl;
        this.sportsApiPushUrl = sportsApiPushUrl;
    }
    ApiConfig.create = function (sportsApiUrl, sportsApiPushUrl) {
        if (sportsApiUrl === void 0) { sportsApiUrl = "https://sbapi.sbtech.com/whltemplate/sportsdata/v2/"; }
        return new ApiConfig(sportsApiUrl, sportsApiPushUrl);
    };
    return ApiConfig;
}());
exports.ApiConfig = ApiConfig;
//# sourceMappingURL=contracts.js.map